export default "__VITE_ASSET__DrN_eYne__"